import {Dialog} from "@mui/material";
import {useDispatch} from "react-redux";
import {clearError} from "features/error/error";
import {
  DialogContentBox,
  DialogTextSubProvider,
  DialogTextProvider,
  DialogActionsContentBox,
  DialogActionsButton
} from "components/styles/styles";
import ErrorPopupImage from 'assets/images/ErrorPopupImage.png';
const ErrorModal = () => {
  const dispatch = useDispatch();
  return (
    <Dialog
      open={true}
      onClose={() => dispatch(clearError(''))}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      PaperProps={{
        sx: { width: '764px', height: '670px', maxWidth: '100%', background: '#FAFAFA' },
      }}
    >
      <DialogContentBox>
        <img src={ErrorPopupImage} alt={'error'} />
        <DialogTextProvider>Error Occurred</DialogTextProvider>
        <DialogTextSubProvider>We encountered an issue while processing your request. Please try again later.</DialogTextSubProvider>
      </DialogContentBox>
      <DialogActionsContentBox>
        <DialogActionsButton variant="contained" onClick={() => dispatch(clearError(''))}>
          Ok
        </DialogActionsButton>
      </DialogActionsContentBox>
    </Dialog>
  )
}

export default ErrorModal;